import { NomenclatureBaseFormDto, type NomenclatureBaseFormInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-base-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { NomenclatureGroupFindInterface } from '@zaoblako/shared/modules/catalog/dtos/nomenclature/nomenclature-group-find.dto';

/** Nomenclature group create and update request body */
export interface NomenclatureGroupFormInterface extends NomenclatureBaseFormInterface {
  /** Parent group */
  parent?: NomenclatureGroupFindInterface;
}

/** Nomenclature group create and update request body - DTO schema */
export const NomenclatureGroupFormDto = SerdeDtoClass.from<NomenclatureBaseFormInterface, NomenclatureGroupFormInterface>(
  NomenclatureBaseFormDto,
  CatalogDtosKeysEnum.NOMENCLATURE_GROUP_FORM_DTO,
  {
    parent: {
      optional: true,
      label: 'Надгруппа',
      serializer: entityLikeSchema,
      checkers: [CatalogCheckersEnum.NOMENCLATURE_GROUP_ASSERT_EXISTS_BY_DTO],
    },
  },
);
